import { useEffect } from 'react';

/**
 * 轻量 SEO meta 注入（title + meta[name=description]）。
 * 不引 helmet 类库：预渲染（scripts/prerender.mjs）在真实 Chromium 里跑完
 * 所有 effect 后落盘，爬虫拿到的就是逐页唯一的 title/description。
 * （Bing 站长 2026-10-13 审计：8 页 meta description 雷同——此前只有
 * learn 文章页设 title、全站共用 index.html 的默认 description。）
 */
export function useSeoMeta(title: string, description: string): void {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [title, description]);
}

/** 声明本页不进索引（支付回跳等功能页，无内容价值也不该被收录）。 */
export function useNoIndex(): void {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    meta.content = 'noindex,nofollow';
  }, []);
}
